module.exports = __webpack_public_path__ + "static/media/upload.7da0cc85.svg";